import { Routes } from '@angular/router';
import { authGuard, guestGuard } from './core/guards/auth.guard';
import { ShellComponent } from './layout/shell/shell.component';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () => import('./features/auth/login/login.component').then(c => c.LoginComponent)
  },
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'usuarios', pathMatch: 'full' },
      {
        path: 'usuarios',
        loadComponent: () => import('./features/users/users-list/users-list.component').then(c => c.UsersListComponent)
      },
      {
        path: 'cvs',
        loadComponent: () => import('./features/cvs/cvs-list/cvs-list.component').then(c => c.CvsListComponent)
      },
      {
        path: 'soporte',
        loadComponent: () => import('./features/support/support-list/support-list.component').then(c => c.SupportListComponent)
      },
      {
        path: 'metricas',
        loadComponent: () => import('./features/metrics/metrics.component').then(c => c.MetricsComponent)
      }
    ]
  },
  { path: '**', redirectTo: 'usuarios' }
];
